// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"_99bc82d2","withDimBackground":"_33aacd70"};